import { MODULES } from "@/constants";
import { IPermissions } from "@/modules/User/user.interface";
import routes from "@/routes";
import { lazy } from "react";
import CompanyInsightBetaRoutes from "./companyInsightBeta.routes";
import ProfileInsightBetaRoutes from "./profileInsightBeta.routes";
const VisitorInsight = lazy(() => import("@/modules/VisitorInsight"));

/**
 * The graduated pages, and only those.
 *
 * The first-generation Company Insights and Profile Insights and the Keyword
 * Settings page are no longer registered. Their modules are still on disk and
 * still compile — several live features outside this tree import symbols from
 * them (`SiteVisitorAudience`, `HeyReach`, `CustomFilterDrawer`), so deleting
 * them is a separate job that has to extract those first. Unregistering is what
 * makes them unreachable, and it is trivially reversible.
 *
 * The permission keys are UNCHANGED. `COMPANY_VISITOR_INSIGHTS` and
 * `PROFILE_VISITOR_INSIGHTS` gate the pages that remain, so neither may be
 * removed with the pages they used to gate.
 */
const VisitorInsightRoutes = (permission: IPermissions) => {
  const children = [];
  if (permission[MODULES.COMPANY_VISITOR_INSIGHTS]) {
    children.push(CompanyInsightBetaRoutes);
  }
  if (permission[MODULES.PROFILE_VISITOR_INSIGHTS]) {
    children.push(ProfileInsightBetaRoutes);
  }
  return {
    element: <VisitorInsight />,
    path: routes.VISITOR_INSIGHTS.INDEX,
    children,
  };
};

export default VisitorInsightRoutes;
